// Auto-generated at build time. Default fallback for dev/local contexts.
export const VERSION = 'pre-release';
